import React, { useState } from "react";
import "../../css/LoginRecovery.css";
import { dividerClasses } from "@mui/material";
import logo from "../../assets/cargotool.png";
import { Link } from "react-router-dom";
import Button from "../../components/input/Button";
const EmailForm = ({ onNext }) => {
  const [email, setEmail] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    onNext(email);
  };

  return (
    <div>
      <form className="email-form" onSubmit={handleSubmit}>
        <img
          src={logo}
          style={{
            width: "200px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "auto",
          }}
          alt="logo"
        />
        <h1 className="title">Password Recovery</h1>
        <p>Enter your Email below..</p>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Email"
        />
        <Button className="next-btn" type="submit" label="Next" />
      </form>
      <p>
        <Link to={"/login"} className="back-to-login">
          Back to Login
        </Link>
      </p>
    </div>
  );
};

export default EmailForm;
